import { Node } from '@cast/types';

import { Detail } from 'components/drawer';

import { isNodeUnschedulable } from '../NodeList/utils';

import { InfoTooltip, Stack } from '@cast/design-system';

type Props = { node?: Node };

const getUnschedulableValue = (node?: Node): string => {
  if (!node) {
    return '-';
  }
  return isNodeUnschedulable(node) ? 'Yes' : 'No';
};

export const NodeRemovalSection = ({ node }: Props) => {
  const unremovable =
    node?.unremovable !== undefined ? (node.unremovable ? 'Yes' : 'No') : '-';

  return (
    <Stack gap={8}>
      <Detail
        testId="node-details-unschedulable"
        title="Unschedulable:"
        detail={getUnschedulableValue(node)}
      />
      <Detail
        testId="node-details-unremovable"
        title={
          <>
            Unremovable
            <InfoTooltip
              title="Node is marked as not to be evicted or deleted."
              noDefaultIconStyling={false}
            />
            :
          </>
        }
        detail={unremovable}
      />
    </Stack>
  );
};
